import { useQuery } from "@apollo/client";
import React, { useState, useEffect, createContext, useContext, Children } from "react";
import {GET_REGISTER_USER} from 'schemas/register';

const RegisterContext = createContext();
export default RegisterContext

export function RegisterProvider({children}) {
  const [user, setUser] = useState(null)
  const [process, setProcess] = useState('initial');

  const { loading, error, data, refetch:refetchUser } = useQuery(GET_REGISTER_USER, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (data && data.register) {
      if (data.register.verified) {
        setProcess('steps')
      }
      setUser(data.register)
    }
  }, [data])


  return (
    <RegisterContext.Provider value={{
      user,
      setUser,
      refetchUser,
      process,
      goToStepsProcess: () => setProcess('steps')
      }}>
      {children}
    </RegisterContext.Provider>
  )
}